import { render, staticRenderFns } from "./tblCalculationsTable.vue?vue&type=template&id=08e85cf3"
import script from "./tblCalculationsTable.vue?vue&type=script&lang=js"
export * from "./tblCalculationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports